import { render } from "./edit.vue?vue&type=template&id=d236a426&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=d236a426&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d236a426"],['__file',"src/views/chess/service/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d236a426"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d236a426', __exports__)) {
    console.log('reload')
    api.reload('d236a426', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=d236a426&scoped=true", () => {
    console.log('re-render')
    api.rerender('d236a426', render)
  })

}


export default __exports__